<template>
    <div class="modal-card" style="width: 800px; height: 800px">
        <header class="modal-card-head">
            <div class="modal-card-title">
                <p>
                    <b-icon icon="user" class="m-2"></b-icon>
                    {{ sst }}
                </p>
                <div class="field has-text-right">
                    <b-tag type="is-info">{{ uuid }}</b-tag>
                </div>
            </div>
        </header>
        <section class="modal-card-body">

            <div class="columns">
                <div class="column">
                    <b-field label="Coût">
                        <b-input type="number" min="0" step="0.01" v-model="payload.cost">
                        </b-input>
                    </b-field>

                    <b-field label="N° devis">
                        <b-input type="text" v-model="payload.devis">
                        </b-input>
                    </b-field>

                    <b-field label="Commentaire">
                        <b-input type="text" v-model="payload.comment">
                        </b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Date de livraison">
                        <b-datepicker
                            v-model="payload.livraison"
                            show-week-number
                            locale="fr-FR"
                            placeholder="Sélectionner"
                            icon="calendar"
                            icon-right="pen"
                            icon-right-clickable
                            @icon-right-click="clearDate()"
                            trap-focus>
                        </b-datepicker>
                    </b-field>

                    <b-field label="Famille de travaux">
                        <b-select
                            v-model="payload.famille"
                            placeholder="Sélectionner"
                            @input="setActions">
                            <option
                                v-for="option in typotravaux"
                                :value="option.famille"
                                :key="option.famille">
                                {{ option.famille }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Action de travaux">
                        <b-select
                            placeholder="Sélectionner"
                            v-model="payload.action"
                            @input="setIntitules">
                            <option
                                v-for="option in actions"
                                :value="getActionValue(option)"
                                :key="getActionValue(option)">
                                {{ getActionName(option) }}
                            </option>
                        </b-select>
                    </b-field>
                    
                    <b-field label="Intitulé">
                        <b-select
                            placeholder="Sélectionner"
                            v-model="payload.intitule">
                            <option
                                v-for="option in intitules"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="editTodo">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "SSTEditModal",
        props: {
            uuid: {
                type: String,
                required: true
            },
            sst: {
                type: String,
                required: true
            },
            cost: {
                required: true
            },
            devis: {
                type: String,
                required: false
            },
            comment: {
                type: String,
                required: false
            },
            livraison: {
                required: false
            },
            famille: {
                type: String,
                required: false
            },
            action: {
                type: String,
                required: false
            },
            intitule: {
                type: String,
                required: false
            },
            typotravaux: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                payload: {
                    uuid: this.uuid,
                    sst: this.sst,
                    cost: this.cost,
                    devis: this.devis,
                    comment: this.comment,
                    livraison: this.livraison ? new Date(this.livraison) : null,
                    famille: this.famille,
                    action: this.action,
                    intitule: this.intitule
                },
                actions: [],
                intitules: []
            };
        },
        mounted() {
            // Initialiser les actions et intitulés à l'ouverture du modal
            if (this.payload.famille) {
                this.initializeActions();
            }
            if (this.payload.action) {
                this.initializeIntitules();
            }
        },
        methods: {
            initializeActions() {
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (famille) {
                    this.actions = famille.actions;
                }
            },
            
            initializeIntitules() {
                if (!this.payload.action || !this.payload.famille) return;
                
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (!famille) return;
                
                const action = famille.actions.find(a => {
                    if (typeof a === 'string') {
                        return a === this.payload.action;
                    } else {
                        return a.name === this.payload.action;
                    }
                });
                
                if (action && typeof action === 'object' && action.subcategories) {
                    this.intitules = action.subcategories;
                } else {
                    this.intitules = [this.payload.action];
                }
            },
            
            setActions() {
                this.payload.action = null;
                this.payload.intitule = null;
                this.intitules = [];
                
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (famille) {
                    this.actions = famille.actions;
                }
            },
            
            setIntitules() {
                this.payload.intitule = null;
                this.intitules = [];
                
                if (!this.payload.action) return;
                
                const famille = this.typotravaux.find(f => f.famille === this.payload.famille);
                if (!famille) return;
                
                const action = famille.actions.find(a => {
                    if (typeof a === 'string') {
                        return a === this.payload.action;
                    } else {
                        return a.name === this.payload.action;
                    }
                });
                
                if (action && typeof action === 'object' && action.subcategories) {
                    this.intitules = action.subcategories;
                } else {
                    this.intitules = [this.payload.action];
                }
            },
            
            getActionValue(action) {
                return typeof action === 'string' ? action : action.name;
            },
            
            getActionName(action) {
                return typeof action === 'string' ? action : action.name;
            },
            
            clearDate() {
                this.payload.livraison = null;
            },
            
            editTodo() {
                // Vérifier la famille de travaux
                if (!this.payload.famille || this.payload.famille === '') {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner une famille de travaux`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier le commentaire si "Autre" est sélectionné dans une des catégories
                if (((this.payload.famille !== undefined && this.payload.famille === 'Autre') || 
                    (this.payload.action !== undefined && this.payload.action === 'Autre') || 
                    (this.payload.intitule !== undefined && this.payload.intitule === 'Autre')) && 
                    (!this.payload.comment || this.payload.comment.trim() === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de renseigner un commentaire pour préciser "Autre"`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier l'action de travaux (sauf si famille = "Autre")
                if (this.payload.famille !== 'Autre' && (!this.payload.action || this.payload.action === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner une action de travaux`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier l'intitulé (sauf si famille = "Autre" ou action = "Autre")
                if (this.payload.famille !== 'Autre' && 
                    this.payload.action !== 'Autre' && 
                    (!this.payload.intitule || this.payload.intitule === '')) {
                    this.$buefy.snackbar.open({
                        message: `Merci de sélectionner un intitulé`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Vérifier le coût
                if (!this.payload.cost || this.payload.cost === '' || isNaN(parseFloat(this.payload.cost)) || parseFloat(this.payload.cost) < 0) {
                    this.$buefy.snackbar.open({
                        message: `Merci de saisir un coût valide`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
                    return;
                }
                
                // Si tout est OK
                this.$emit("edit-sst", this.payload);
            }
        }
    };
</script>

<style scoped></style>